<template>
  <div id="intro-3" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Global Commission Rate</h3>
      </div>

      <div class="intro-box__content">
        <p>What percentage of the sale would you like to award your vendor?</p>

        <p><small>*You can override the percentage by vendor from that vendor's settings
          page.</small></p>

        <div class="intro-box__actions">
          <div class="form-field">
            <label class="show-for-sr" for="commission">Commission Percentage</label>
            <div class="grid-x align-middle align-center">
              <div class="cell shrink">
                <input id="commission" class="short-input" type="text"
                       name="commission" placeholder="30">
              </div>

              <div class="cell shrink"><span style="padding-left: 10px;">%</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="intro-box__footer">
      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <button class="button--wide button--alt" @click="changeStep(false)">Back</button>
        </div>

        <div class="cell auto">
          <button :class="['button--wide', chosen === null ? 'disabled': '']" @click="changeStep">
            Next
          </button>

          <div style="padding: 10px 0;"><a href="https://calendly.com/support-visceral/onboarding" target="_blank">Need help with getting setup?</a></div>
        </div>
      </div>

<!--      <div class="intro-box__skip">configure later</div>-->
    </div>

    <div class="intro-box__pagination">
      <span></span>
      <span></span>
      <span></span>
      <span class="active"></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [
    client
  ],
  data: function () {
    return {
      chosen: null
    }
  },
  methods: {
    changeStep (next = true) {
      if (next && this.chosen) {
        let commissionElement = document.getElementById('commission')

        this.request('put', '/settings/settings/' + this.$store.state.settings.id + '/retrieve-update/', {
          global_commission: commissionElement.value
        }).then(response => {
          this.$emit('changeStep', next)
        })
      } else if (!next) {
        this.$emit('goToStep', 'step4')
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      let commissionElement = document.getElementById('commission')

      const verifyCommission = (e) => {
        if (e.target.value.length > 0) {
          this.chosen = true
        } else {
          this.chosen = null
        }
      }

      commissionElement.addEventListener('keyup', verifyCommission)
    })
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step4A.vue